export default "__VITE_ASSET__2W_79lUG__"